<template>
    <div id="Console" v-loading="loading">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>订单号: {{ orderDetail.orderNo }}</span>
                <span class="order-time"
                    >下单时间: {{ orderDetail.orderDateTime }}</span
                >
                <span v-if="orderDetail.orderStatus == 0" class="order-time"
                    >订单状态:
                    <span class="order-completed">支付成功</span></span
                >
                <span
                    v-if="orderDetail.orderStatus == 1"
                    class="order-time order-error"
                    >订单状态: 支付错误</span
                >
                <span v-if="orderDetail.orderStatus == 2" class="order-time red"
                    >订单状态: 未支付</span
                >
                <span
                    v-if="orderDetail.orderStatus == 3"
                    class="order-time order-cancle"
                    >订单状态: 已取消</span
                >
                <span class="order-time" v-if="orderDetail.orderStatus == 2 && orderDetail.effective"
                    >剩{{ orderDetail.effective }}自动关闭</span
                >
                <el-button
                    v-if="orderDetail.orderStatus == 2"
                    style="float: right; padding: 3px 0;margin-left:12px"
                    type="text"
                    @click="cancelOrder"
                    >取消订单</el-button
                >
                <el-button
                    v-if="orderDetail.orderStatus == 2"
                    style="float: right; padding: 3px 0"
                    type="text"
                    @click="toPaid"
                    >待付款</el-button
                >
            </div>
            <div>
                <el-row :gutter="20">
                    <el-col
                        :span="7"
                        v-if="
                            orderDetail.orderStatus == 0 ||
                                orderDetail.orderStatus == 2
                        "
                    >
                        <h4>付款信息</h4>
                        <p>金额 : {{ orderDetail.totalPrice }}</p>
                        <p
                            v-for="(item, index) in orderDetail.payments"
                            :key="item.payType"
                        >
                            支付方式: {{ item.payDesc }}
                        </p>
                        <p>交易编号 : {{ orderDetail.txnId }}</p>
                        <p>支付时间 : {{ orderDetail.paymentDateTime }}</p>
                    </el-col>
                    <el-col :span="6">
                        <h4>商品信息</h4>
                        <div
                            v-for="(item, index) in orderDetail.products"
                            :key="item.productNo"
                        >
                            <p>产品名称 : {{ item.productName }}</p>
                            <p>单价 : {{ item.price }}</p>
                        </div>
                        <p>总数量 : {{ orderDetail.totalAmount }}</p>
                        <p class="vouNoList">券号 : {{ orderDetail.vmsNo }}</p>
                        <template v-if="orderDetail.orderType == 1">
                            <p>免费招待</p>
                            <p>优惠金额:{{ orderDetail.totalPrice }}</p>
                        </template>
                    </el-col>
                    <el-col :span="6">
                        <h4>收银员信息</h4>
                        <p>服务员 : {{ orderDetail.salesId }}</p>
                    </el-col>
                </el-row>
            </div>
        </el-card>
        <el-dialog
            title="请使用收款POS机扫描二维码"
            :visible.sync="centerDialogVisible"
            @close="close"
            width="30%"
            center>
            <div style='text-align:center'>
                <img :src="src" width=200px height=200px />
                <p style='text-align:center'></p>
                <p style='text-align:center'>订单号: {{orderDetail.orderNo}} </p>
                <p style='text-align:center'>金额: {{orderDetail.totalPrice}} </p>
                <p style='text-align:center'>请在此页面停留等待支付结果</p>
                <p style='text-align:center' class='ordertime'><i class='el-icon-time' ></i><span>{{orderTime}}</span></p>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogCancel()">取 消</el-button>
                <el-button type="primary" @click="dialogNoCancel()">确 定</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>

<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
let timer = "";
let timer1 = "";
export default {
    name: 'orderDeatails',
    mixins: [requestMixin, common],
    data () {
        return {
            orderDetail: {},
            loading: false,
            aLiUrl: 'https://static.oschina.net/new-osc/img/wechat_qrcode.jpg?t=1484694603000',
            centerDialogVisible:false,
            src:'',
            orderTime:''
        }
    },
    mounted () {
        let { orderNo, userId } = this.$route.query;
        this.$nextTick(() => {
            this.getDetailsList(orderNo, userId)
        })
    },
    methods: {
        getDetailsList (orderNo, userId) {
            let that = this;
            let params = {
                act: 'orderDetail',
                orderNo,
                userId
            }
            that.loading = true;
            that.delType(params).then(res => {
                that.loading = false;
                let { data } = res.data;
                that.orderDetail = data;
            }).catch(error => {
                // console.log(error)
            })
        },
        //取消订单
        cancelOrder (e) {
            let that = this;
            let { orderNo, salesId, vmsNo } = that.orderDetail;
            let userId = salesId;
            let params = {
                act: 'cancelPay',
                userId: salesId,
                orderNo,
                vmsNo
            }
          
            that.$confirm('是否取消该订单, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.handleCancel(params);
            }).catch(() => {
                that.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        handleCancel (params) {
            let that = this;
            let { userId, orderNo } = params;
            that.delType(params).then((res) => {
                let { status } = res.data;
                if (status) {
                    this.$message({
                        type: 'success',
                        message: '已取消订单!'
                    });
                    that.getDetailsList(orderNo, userId);
                } else {
                    that.$alert('取消订单失败', '提示', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true
                    })
                }
            }).catch((error) => {
                that.$alert('请求不到数据或网络连接异常', '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                    center: true
                })
            })
        },
        toPaid () {
            let aLiUrl = this.aLiUrl;
            //监听图片加载
            let that = this;
            that.getImg();

        },
        //监听图片加载
        getImg () {
            let that = this;
            let { orderNo, totalPrice } = that.orderDetail;
            let userId = sessionStorage.getItem("userId");
            that.loading = true;
            let params = {
                act: 'goPay',
                orderNo,
                userId
            }
            that.delType(params).then(res => {
                let src = `${apis.baseURL}?act=goPay&orderNo=${orderNo}&userId=${userId}`;
                that.loading = false;
                that.src = src;
                that.centerDialogVisible = true;
                that.getCheckOrderTime(orderNo, userId).then((res) => {
                    let { code, status, data } = res.data;
                    let orderTime = 0;
                    if (code == 200 && status == true) {
                        timer1 = setInterval(function () {
                            orderTime++ ;
                            that.orderTime = that.formatSeconds(orderTime);
                            if (orderTime == data) {
                                clearInterval(timer1);//到时间取消执行
                                // clearInterval(timer);//到时间取消执行
                                setTimeout(() => {
                                    that.centerDialogVisible = false;
                                    clearInterval(timer);//到时间取消执行
                                    that.getDetailsList(orderNo, userId);
                                },2000)
                            }
                        }, 1000);//每1000毫秒执行一次
                    }else {
                        clearInterval(timer1)
                        clearInterval(timer)
                        that.centerDialogVisible = false;
                        that.getDetailsList(orderNo, userId);
                    }
                })
                timer = setInterval(() => {
                    // console.log('1')
                    that.payStatus(orderNo, userId);
                }, 1000)
            })
        },

        //监听支付
        payStatus (orderNo, userId) {
            let that = this;
            let params = {
                act: 'payStatus',
                orderNo,
                userId
            }
            that.delType(params).then((res) => {
                let { payStatus } = res.data.data;
                if (payStatus && payStatus.paySuccess) {
                    clearInterval(timer);
                    clearInterval(timer1);
                    that.$message({
                        type: 'success',
                        message: `支付成功`
                    })
                    that.centerDialogVisible = false;
                    that.getDetailsList(orderNo, userId)
                } else if (payStatus && payStatus.paySuccess == false && payStatus.orderOut) {
                    clearInterval(timer);
                    clearInterval(timer1);
                    that.$message({
                        type: 'warning',
                        message: '订单超时，支付取消'
                    })
                    that.centerDialogVisible = false;
                    that.getDetailsList(orderNo, userId)
                }


            })
        },

         //监听剩余时间
        getCheckOrderTime (orderNo, userId) {
            let that = this;
            let params = {
                act: 'checkOrderTime',
                orderNo,
                userId
            }
            let orderTimePromise = new Promise((resolve, reject) => {
                that.delType(params).then((res) => {
                    resolve(res)
                }).catch((error) => {
                    reject(error)
                })
            })
            return orderTimePromise;

        },

        // dialogCancel(){
        //     let that = this;
        //     //取消
        //     that.centerDialogVisible = false;
        //     clearInterval(timer);
        //     console.log(timer)
        //     clearInterval(timer1);
        // },
        // dialogNoCancel(){
        //     let that = this;
        //     that.centerDialogVisible = false;
        //     clearInterval(timer);
        //     clearInterval(timer1);
        // },
        // //关闭
        close(){
            let { orderNo, userId } = this.$route.query;
            this.centerDialogVisible = false;
            clearInterval(timer);
            clearInterval(timer1);
            // this.getDetailsList(orderNo, userId)
      
        }
    },

}
</script>

<style scoped>
.order-time {
    margin-left: 20px;
}
.red {
    color: red;
}
.order-completed {
    color: #00c468;
}
.order-error {
    color: orange;
}
.order-cancle {
    color: slategray;
}
.vouNoList {
    width: 100%;
    word-wrap: break-word;
    word-break: break-all;
    height: auto;
    overflow: hidden;
}
.ordertime{
    padding: 10px 0;
    font-size: 28px;
}
.ordertime span{
    margin: 10px;
}
.el-icon-time{
    font-size: 28px;
}
</style>